import { render, staticRenderFns } from "./AiFabricSearch.vue?vue&type=template&id=24c2ed9c&scoped=true"
import script from "./AiFabricSearch.vue?vue&type=script&lang=js"
export * from "./AiFabricSearch.vue?vue&type=script&lang=js"
import style0 from "./AiFabricSearch.vue?vue&type=style&index=0&id=24c2ed9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2ed9c",
  null
  
)

export default component.exports